import { render, staticRenderFns } from "./UGCDataUpload.vue?vue&type=template&id=681a8e80&scoped=true"
import script from "./UGCDataUpload.vue?vue&type=script&lang=js"
export * from "./UGCDataUpload.vue?vue&type=script&lang=js"
import style0 from "./UGCDataUpload.vue?vue&type=style&index=0&id=681a8e80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681a8e80",
  null
  
)

export default component.exports